var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleAudit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.023,26.74l-4.887-4.73,1.247-1.289,3.536,3.422,6.96-7.9,1.345,1.187Z",
    transform: "translate(-668.396 -8.194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.483,58.272l-24.036-.033a5.512,5.512,0,0,1-5.505-5.506V30.919a5.511,5.511,0,0,1,5.5-5.506H696.9v1.794H678.447a3.708,3.708,0,0,0-3.712,3.712V52.732a3.717,3.717,0,0,0,3.712,3.712l24.036.033a3.717,3.717,0,0,0,3.711-3.712V32.47h1.794v20.3A5.513,5.513,0,0,1,702.483,58.272Z",
    transform: "translate(-672.941 -6.397)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.092,
    height: 1.794,
    transform: "translate(8.292 30.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.565,
    height: 1.794,
    transform: "translate(8.292 39.089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.183,36.663a13.575,13.575,0,1,1,13.573-13.575A13.591,13.591,0,0,1,704.183,36.663Zm0-25.356a11.781,11.781,0,1,0,11.779,11.78A11.794,11.794,0,0,0,704.183,11.307Z",
    transform: "translate(-669.479 -9.513)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleAudit);
export default __webpack_public_path__ + "static/media/icon_module_audit.159f52f671c0eb63c0bd6d848db0b84d.svg";
export { ForwardRef as ReactComponent };